import { render, staticRenderFns } from "./BestPlayer.vue?vue&type=template&id=4f259462&scoped=true&"
import script from "./BestPlayer.vue?vue&type=script&lang=js&"
export * from "./BestPlayer.vue?vue&type=script&lang=js&"
import style0 from "./BestPlayer.vue?vue&type=style&index=0&id=4f259462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f259462",
  null
  
)

export default component.exports